export default "__VITE_ASSET__BDA_$ctq__"